import { apiService } from '.';
import { TOKEN } from '../contexts/authContext';

export const asyncPostBulkLoad = (formdata: any) => {
    return apiService.post('/api/case-manager', formdata, undefined, {
        accept: '*/*',
        Authorization: 'Bearer ' + sessionStorage.getItem(TOKEN),
    });
};

export const asyncGetUserByRol = async (rol?: string) => {
    return await apiService.get('/api/users/by-rol', {
        rol: rol,
    });
};

export const asyncGetCaseManager = async (page?: number, pageSize?: number) => {
    return await apiService.get('/api/case-manager', {
        limit: pageSize || 20,
        page: page || 0,
    });
};

export const asyncPatchUserRandom = async () => {
    return await apiService.put('/api/case-manager');
};

export const asyncPatchUserOneToOne = async (
    caseId: string,
    userId: string
) => {
    return await apiService.put(
        `/api/case-manager/one-to-one?caseId=${caseId}&userId=${userId}`
    );
};

export const asyncGetCaseManagerId = async (idCase: string) => {
    return await apiService.get(`/api/case-manager/${idCase}`);
};
